import * as React from 'react';
import { NotificationCard } from '@digital/react-aviva-atom';
import { RootState } from '../../app/store';
import { connect } from 'react-redux';
import './ProvisionalBooking.css';
import moment from 'moment';
import { TIMEZONE } from '../../utils/constants';

interface InjectedProps {
    userSelection: Date | undefined;
}

export type Props = InjectedProps;

export class ProvisionalBookingInfo extends React.PureComponent<Props> {
    static defaultProps: Partial<Props> = {
        userSelection: undefined,
    };
    constructor(props: Props) {
        super(props);
    }

    getTimeInfo() {
        const { userSelection } = this.props;
        if (userSelection) {
            return moment(userSelection).tz(TIMEZONE).format('h:mmA, dddd, MMMM Do YYYY');

        } else {
            return moment().tz(TIMEZONE).format('h:mmA, dddd, MMMM Do YYYY');
        }
    }

    render() {
        const timeInfo = this.getTimeInfo();
        const timeArray = timeInfo.split(',');
        return (
            <div className="provisionalBooking" data-testid="provisional-booking">
                <NotificationCard>
                    {/* tslint:disable-next-line:max-line-length*/}
                    You have provisionally selected <strong>{timeArray[0]}</strong> on <strong>{timeArray.slice(1).join(' ')}</strong> as your first driving lesson. This is subject to availability and will be confirmed on payment.
                </NotificationCard>
            </div>
        );
    }

}

export function mapStateToProps(state: RootState) {
    return {
        userSelection: state.userSelection.lessonTime
    };
}

export default connect<InjectedProps, {}>(mapStateToProps)(ProvisionalBookingInfo);